module.exports = __webpack_public_path__ + "static/media/website-02.018a6853.png";